


import One from '../Assets/1.jpg'
import Two  from '../Assets/2.jpg'
import Three from '../Assets/3.jpg'
import Four from '../Assets/4.jpg'
import Five from '../Assets/5.jpg'
import Six from '../Assets/6.jpg'
import Seven from '../Assets/7.jpg'
import Eight from '../Assets/8.jpg'
import Nine from '../Assets/9.jpg'
import Ten from '../Assets/10.jpg'
import Eleven from '../Assets/11.jpg'

import card1 from '../Assets/card1.mp4'
import card2 from '../Assets/card2.mp4'
import card3 from '../Assets/card3.mp4'
import card4 from '../Assets/card4.mp4'
import card5 from '../Assets/card5.mp4'
import card6 from '../Assets/card6.mp4'
import card7 from '../Assets/card7.mp4'
import card8 from '../Assets/card8.mp4'



import card9 from '../Assets/card5.mp4'





export const projectCategories = [
  "All",
  "Event Production",
  "Film",
  "Video Production",
  "Photography",
];




const projects = [
  // =========================================================
  // 01 — CALLING ALL CARS
  // =========================================================
  {
    id: 1,
    slug: "calling-all-cars",
    title: "Calling All Cars",
    client: null,
    category: "Event Production",
    year: "2026",
    location: "Dubai, UAE",

    image:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=1400&q=85",

    heroImage:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=2200&q=90",

    video: card1,

    videoThumbnail:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=2200&q=90",

    services: [
      "Event Production",
      "Creative Direction",
      "Film Production",
      "Post Production",
    ],

    description:
      "An energetic event production created to capture the excitement, scale and atmosphere of a major automotive gathering, combining dynamic visuals with cinematic storytelling.",

    challenge:
      "The production needed to communicate the energy of the motor show while showcasing cars, bikes, crowds and the overall event atmosphere in a visually engaging way.",

    approach:
      "We focused on fast-paced cinematic coverage, dynamic camera movement, detailed automotive shots and atmospheric event footage to create an immersive visual experience.",

    result:
      "The final film delivered a high-energy visual story that captured the excitement of the event and created engaging content suitable for promotional and social media communication.",

    gallery: [],
  },

  // =========================================================
  // 02 — A STORY OF CONFIDENCE
  // =========================================================
  {
    id: 2,
    slug: "a-story-of-confidence",
    title: "A Story of Confidence",
    client: null,
    category: "Event Production",
    year: "2026",
    location: "Dubai, UAE",

    image:
      "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=1400&q=85",

    heroImage:
      "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=2200&q=90",

    video:card2,
    videoThumbnail:
      "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=2200&q=90",

    services: [
      "Event Production",
      "Creative Direction",
      "Film Production",
      "Post Production",
    ],

    description:
      "A cinematic event story centered around confidence, meaningful connections and women inspiring one another through powerful visual storytelling.",

    challenge:
      "The production needed to capture authentic emotion and meaningful human connections while maintaining a polished and cinematic visual identity.",

    approach:
      "We combined expressive portraits, event atmosphere, natural interactions and carefully composed cinematic sequences to create an emotional and inspiring narrative.",

    result:
      "The final production transformed the event into a memorable visual story focused on confidence, connection and inspiration.",

    gallery: [],
  },

  // =========================================================
  // 03 — DUBAI REALLY SHOWED UP
  // =========================================================
  {
    id: 3,
    slug: "dubai-really-showed-up",
    title: "Dubai Really Showed Up",
    client: null,
    category: "Event Production",
    year: "2026",
    location: "Dubai, UAE",

    image:
      "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1400&q=85",

    heroImage:
      "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=2200&q=90",

    video:card3,

    videoThumbnail:
      "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=2200&q=90",

    services: [
      "Event Production",
      "Creative Direction",
      "Film Production",
      "Post Production",
    ],

    description:
      "A vibrant event production celebrating the energy, scale and visual character of Dubai through cinematic event coverage.",

    challenge:
      "The project required a strong visual approach capable of capturing the atmosphere and energy of the event while presenting Dubai as an impactful backdrop.",

    approach:
      "We used dynamic compositions, cinematic movement, atmospheric shots and carefully selected event moments to build a visually engaging story.",

    result:
      "The final video captured the excitement of the event and presented a polished visual narrative designed for brand communication and digital campaigns.",

    gallery: [],
  },

  // =========================================================
  // 04 — ETOE PRODUCTIONS
  // =========================================================
  {
    id: 4,
    slug: "etoe-productions",
    title: "ETOE Productions",
    client: "ETOE Productions",
    category: "Film",
    year: "2026",
    location: "Dubai, UAE",

    image:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=85",

    heroImage:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=2200&q=90",

    video:card4,

    videoThumbnail:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=2200&q=90",

    services: [
      "Creative Direction",
      "Film Production",
      "Cinematography",
      "Post Production",
    ],

    description:
      "Our own production work, featuring cinematic storytelling, creative direction, dynamic camera movements, and polished post-production across a range of projects.",

    challenge:
      "The film needed to communicate the creative identity and production capabilities of ETOE Productions through a concise and visually distinctive brand piece.",

    approach:
      "We built the film around cinematic camera work, controlled movement, detailed visual compositions, strong typography and polished editing to create a premium production identity.",

    result:
      "The final production established a strong visual introduction to ETOE Productions and showcased the company's approach to creative filmmaking and visual storytelling.",

    gallery: [],
  },

  // =========================================================
  // 05 — AARIKA REAL ESTATE
  // =========================================================
  {
    id: 5,
    slug: "aarika-real-estate",
    title: "Aarika Real Estate",
    client: "Aarika Real Estate",
    category: "Video Production",
    year: "2026",
    location: "Dubai, UAE",

    image:
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1400&q=85",

    heroImage:
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=2200&q=90",

    video:card5,

    videoThumbnail:
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=2200&q=90",

    services: [
      "Video Production",
      "Cinematography",
      "Creative Direction",
      "Post Production",
    ],

    description:
      "Professional video production focused on cinematic visuals, creative camera work, and polished storytelling that brings the brand's communication to life.",

    challenge:
      "The production required a professional visual language that could present the brand through cinematic imagery and engaging storytelling.",

    approach:
      "We used creative camera work, refined framing, smooth visual sequences and polished editing to create a professional brand-focused video.",

    result:
      "The final video delivered polished visual content designed to strengthen the brand's communication across digital platforms.",

    gallery: [],
  },

  // =========================================================
  // 06 — JASMINE
  // =========================================================
  {
    id: 6,
    slug: "jasmine",
    title: "Jasmine",
    client: "Jasmine",
    category: "Video Production",
    year: "2026",
    location: "Dubai, UAE",

    image:
      "https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=1400&q=85",

    heroImage:
      "https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=2200&q=90",

    video:card6,

    videoThumbnail:
      "https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=2200&q=90",

    services: [
      "Video Production",
      "Cinematography",
      "Creative Direction",
      "Post Production",
    ],

    description:
      "A visually driven video production created with expressive cinematography, thoughtful framing, and smooth visual sequences to deliver engaging brand content.",

    challenge:
      "The project required an expressive and visually engaging approach that could communicate the subject and brand message with clarity and style.",

    approach:
      "We focused on expressive cinematography, thoughtful compositions, smooth transitions and carefully paced visual sequences.",

    result:
      "The finished video created engaging brand content with a polished and contemporary visual identity.",

    gallery: [],
  },

  // =========================================================
  // 07 — 1011 PROPERTIES
  // =========================================================
  {
    id: 7,
    slug: "1011-properties",
    title: "1011 Properties",
    client: "1011 Properties",
    category: "Video Production",
    year: "2026",
    location: "Dubai, UAE",

    image:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1400&q=85",

    heroImage:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=2200&q=90",

    video:card7,

    videoThumbnail:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=2200&q=90",

    services: [
      "Video Production",
      "Cinematography",
      "Creative Direction",
      "Post Production",
    ],

    description:
      "High-quality video content produced with a focus on dynamic cinematography, refined visuals, and a strong visual narrative that reflects the brand professionally.",

    challenge:
      "The project required a polished production style capable of presenting the brand professionally while maintaining strong visual impact.",

    approach:
      "We combined dynamic cinematography, refined framing, smooth camera movement and structured editing to build a strong visual narrative.",

    result:
      "The final production delivered premium brand content with a professional visual identity and strong storytelling.",

    gallery: [],
  },

  // =========================================================
  // 08 — THE FRESH STORY
  // =========================================================
  {
    id: 8,
    slug: "the-fresh-story",
    title: "The Fresh Story",
    client: "The Fresh Story",
    category: "Video Production",
    year: "2026",
    location: "Dubai, UAE",

    image:
      "https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=1400&q=85",

    heroImage:
      "https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=2200&q=90",

    video:card8,

    videoThumbnail:
      "https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=2200&q=90",

    services: [
      "Video Production",
      "Creative Direction",
      "Cinematography",
      "Post Production",
    ],

    description:
      "Creative video production combining natural visuals, engaging compositions, and fluid storytelling to create fresh and memorable content.",

    challenge:
      "The production needed to communicate a fresh brand personality through natural imagery and an engaging visual narrative.",

    approach:
      "We combined natural visuals, engaging compositions, fluid camera movement and polished editing to create a fresh storytelling style.",

    result:
      "The final video created memorable brand content with an approachable and visually engaging identity.",

    gallery: [],
  },

  // =========================================================
  // 09 — KEZAD GROUP
  // =========================================================
  {
    id: 9,
    slug: "kezad-group",
    title: "KEZAD Group",
    client: "KEZAD Group",
    category: "Film",
    year: "2026",
    location: "UAE",

    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=85",

    heroImage:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2200&q=90",

    video:card9,

    videoThumbnail:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2200&q=90",

    services: [
      "Corporate Video Production",
      "Cinematography",
      "Creative Direction",
      "Post Production",
    ],

    description:
      "Corporate video production showcasing KEZAD Group through impactful visuals, structured storytelling, and professional cinematography designed for a strong brand presence.",

    challenge:
      "The project required a corporate visual language that could communicate the scale, professionalism and identity of KEZAD Group.",

    approach:
      "We combined impactful location footage, structured storytelling, aerial-style establishing visuals, professional cinematography and polished editing.",

    result:
      "The final production presented KEZAD Group with a strong and professional visual presence suitable for corporate communication.",

    gallery: [],
  },

 

  // =========================================================
// 12 — Photography
// =========================================================
{
  id: 12,
  slug: "photography",
  title: "Framed Emotions",
  client: "Independent",
  category: "Photography",
  year: "2025",
  location: "Al Qudra, UAE",

  image:One,

  heroImage:One,

  // Photography project — no video required
  video: null,
  videoThumbnail: null,

  services: [
    "Photography",
    "Art Direction",
    "Post Production",
  ],

  description:
    "An independent photographic study exploring the relationship between natural landscapes, negative space, texture and changing light.",

  challenge:
    "The objective was to create a visual series capable of communicating the scale and silence of the landscape while maintaining a strong and consistent photographic identity.",

  approach:
    "We worked with minimal compositions, distant subjects and changing natural light. Each image was developed as part of a larger sequence rather than as an isolated photograph.",

  result:
    "The completed series created a restrained visual narrative that could be presented across editorial layouts, exhibitions and digital platforms.",

  // Actual photography gallery
  gallery: [ Two,Three, Four,Five,Six,Seven,Eight,Nine,Ten,Eleven],
},
];

export default projects;